import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CardBalance } from "../../components/CardBalance/CardBalance";
import { CardBienvenida } from "../../components/CardBienvenida/CardBienvenida";
import { CardBlog } from "../../components/CardBlog/CardBlog";
import TableInvestments from "../../components/TableInvestments/TableInvestments";
import { GetAuth } from "../../helpers/Auth";
import "./PageDashboard.css";
import "react-toastify/dist/ReactToastify.css";
import { getArticle } from "../../services/academyService";
import CardSupport from "../../components/CardSupport/CardSupport";
import { fundInvestment, getFunds } from "../../services/fundService";
import { formatCurrencyCOP } from "../../helpers/FormatNumber";
import { INVERSIONES_USUARIO, TOTALES } from "../../constants/mockData";

export default function PageDashboard() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [article, setArticle] = useState(null);
  const [investment, setInvestment] = useState([]);
  
  useEffect(() => {
    // 🔥 Usar datos mock en lugar de API
    setInvestment(INVERSIONES_USUARIO);
  }, []);

  useEffect(() => {
    const userdata = GetAuth();
    setUserData(userdata);

    getArticle()
      .then((res) => {
        if (res) {
          setArticle(res[0]);
        }
      })
      .catch((err) => {
        console.error("Error al cargar artículo:", err);
      });
  }, []);

  useEffect(() => {
    let userdata = GetAuth();
    if (!userData) {
      setUserData(userdata);
    } else if (userdata !== userData) {
      let result = compareObjects(userdata, userData);
      if (!result) {
        setUserData(userdata);
      }
    }
  }, [userData]);

  const compareObjects = (object1, object2) => {
    let isEqual = true;
    let object1String = JSON.stringify(object1);
    let object2String = JSON.stringify(object2);
    if (object1String !== object2String) {
      isEqual = false;
    }
    return isEqual;
  };
  const content2 = () => {
    return (
      <div style={{ fontSize: "13px", textAlign: "start", color: "#4d4d4d" }}>
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry.
      </div>
    );
  };
  const viewMore = () => {
    navigate("/academia/detalles-de-artículo");
  };
  const viewAll = () => {
    navigate("/academia");
  };
  const content3 = () => {
    return (
      <div
        style={{ marginTop: "10px", marginBottom: "20px", cursor: "pointer" }}
        onClick={() => viewMore()}
      >
        <div
          style={{
            fontSize: "12px",
            fontFamily: "Poppins-Bold",
            padding: "3px 10px",
            background: "#b9de2c",
            borderRadius: "5px",
          }}
        >
          Ver más
        </div>
      </div>
    );
  };
  
  // 🔥 Usar totales calculados desde mockData
  const totalInvertido = TOTALES.total_invertido;
  const totalUnidades = TOTALES.total_unidades;
  const totalRendimientos = TOTALES.total_rendimientos;
  const tirPortafolio = TOTALES.tir_portafolio;
  const rendimientosUltimoMes = TOTALES.rendimientos_ultimo_mes;
  
  return (
    <div className="page-dashboard container-animated">
      <div className="row">
        <div className="col-md-6 mb-2">
          <CardBienvenida userData={userData} />
        </div>
        <div className="col-md-6 mb-2">
          <CardSupport />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 col-lg-4 mb-2">
          <CardBalance
            icon="IconBoxBriefcase"
            title="Mi Portafolio"
            saldocop={formatCurrencyCOP(totalInvertido.toString())}
            saldodevisecoin={totalUnidades.toString()}
          />
        </div>
        <div className="col-md-12 col-lg-4 mb-2">
          <CardBalance
            icon="IconBoxSaving"
            title="Mis Dividendos"
            rendimientos={formatCurrencyCOP(rendimientosUltimoMes.toString())}
            rendimientosSubTitle="Último mes"
          />
        </div>
        <div className="col-md-12 col-lg-4 mb-2">
          <CardBalance
            icon="IconBoxGraph"
            title="TIR de Portafolio"
            rendimientosTir={`${tirPortafolio}% E.A.`}
            rendimientosTirSubtitle="último mes"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 col-lg-12">
          {/* <CardTableInvestor /> */}
          <div className="grid-scroll-h-content border-radius">
            <div className="responsive-table">
              <TableInvestments type="grouped"/>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card-container content-box">
            <div className="row">
              <div className="col">
                <div className="table-title " style={{ marginTop: "0px" }}>
                  Aprende con Devise
                </div>
              </div>
              <div className="col-md-12">
                <CardBlog bg_color="#bbacf2" article={article} />
              </div>
              <div className="col-md-12">
                <div className="_card-footer">
                  <div
                    className="_card-footer-right"
                    onClick={() => viewAll()}
                    style={{ cursor: "pointer" }}
                  >
                    Ver todas
                    <li className="arrow-right"></li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
